import { activityGather, errors } from '@services';

export default {
	namespaced: true,
	state: {
		albumInfo: {},
	},
	mutations: {
		SET_ALBUMINFO(state, info) {
			state.albumInfo = info;
		},
	},
	actions: {
		async getAlbumInfo({ commit }, albumId) {
			const { data, ok } = await activityGather.getById(albumId);
			if (!ok) return;
			if (data.data.shareTitle == null) {
				data.data.shareBanner = '';
				data.data.shareTitle = '';
				data.data.shareIntro = '';
				data.data.shareBannerUrl = '';
			}
			commit('SET_ALBUMINFO', data.data);
		},
	},
};
